import script from "./TechnologyView.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnologyView.vue?vue&type=script&setup=true&lang=js"

import "./TechnologyView.vue?vue&type=style&index=0&id=8618e2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8618e2be"]])

export default __exports__